import React from "react";
import PropTypes from "prop-types";
import {PageWrapper} from "BaseComponents/Wrappers";
import {useSelector} from "react-redux";
import {SearchPagination} from "Components/SearchPagination/";

let ListPageWithCategories = ({searchModel, Heading, theme, ...rest}) => {
    return (
        <PageWrapper theme={theme}>
            <SearchPagination Heading={Heading} {...searchModel} {...rest} withCategoriesTags={true} />
        </PageWrapper>
    );
};

ListPageWithCategories.propTypes = {
    Heading: PropTypes.string,
};

export default ListPageWithCategories;
